import React, { forwardRef } from 'react'
import { LatLngExpression, Map } from 'leaflet'
import { MapContainer, TileLayer } from 'react-leaflet'
import Container from '@mui/material/Container'
import { LoadUserLocationList, LoadWorkLocationList } from '@/javascript/domain/usecases'
import { MemberMarker, WorkMarker, MapSubtitle } from './components'

type MapBoxProps = {
  locations: {
    works: LoadWorkLocationList.Model[]
    users: LoadUserLocationList.Model[]
    center: LatLngExpression
    bounds: L.LatLngBounds | null
  }
}

const MapBox = forwardRef<Map, MapBoxProps>(({ locations }, ref) => {
  return (
    <Container sx={{ justifyItems: 'flex-start' }} data-testid="map-box">
      <MapView ref={ref} locations={locations} />
      <MapSubtitle />
    </Container>
  )
})

export default MapBox

const MapView = forwardRef<Map, MapBoxProps>(({ locations: { center, works, users } }, ref) => {
  return (
    <MapContainer center={center} zoom={13} scrollWheelZoom={true} ref={ref}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        subdomains='abcd'
        maxZoom={20}
      />
      {works.map(location => (
        <WorkMarker
          key={`work-marker-${location.id}`}
          position={[parseFloat(location.latitude), parseFloat(location.longitude)]}
          workStatus={location.status}
          workTitle={location.description}
          locationName={location.resourcePlaceName}
          isLate={location.isLate}
        />
      ))}
      {users.map(location => (
        <MemberMarker
          key={`user-marker-${location.id}`}
          position={[parseFloat(location.latitude), parseFloat(location.longitude)]}
          memberName={location.name}
          memberEmail={location.email}
          datetime={location.lastSeenAt}
          description={location.description}
          precision={location.accuracy}
          imageUrl={location.photoUrl}
        />
      ))}
    </MapContainer>
  )
})
